<template>
  <div v-if="type == 'enrollment' || type == 'io'">
    <chart-bar
      :height="height"
      :chartData="gData[group]"
      :options="gOption[group]"
    >
    </chart-bar>
  </div>
  <div v-else-if="type == 'ratio'">
    <chart-bar
      :height="height"
      :chartData="gData[group]"
      :options="optionRatio"
    >
    </chart-bar>
  </div>
  <div v-else-if="type == 'fee'">
    <chart-bar
      :height="height"
      :chartData="gFreeData[group]"
      :options="optionBarFee"
      >
    </chart-bar>
  </div>
  <div v-else-if="type == 'pie'">
    <chart-pie
      :height="height"
      :chartData="dataPie"
      :options="optionPie"
      >
    </chart-pie>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import ChartBar from '../charts/ChartBar.vue'
import ChartPie from '../charts/ChartPie.vue'
Vue.component('chart-bar', ChartBar)
Vue.component('chart-pie', ChartPie)
export default {
  props: [ 'type', 'height', 'year', 'indicator', 'group', 'tempGroups', 'compare', 'items', 'plans', 'diffs', 'diffsRevises', 'fees', 'inout', 'revices', 'mm' ],
  computed: {
    ...mapGetters({
      user: 'auth/user',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      preschool: 'shared/preschool',
      extension: 'shared/extension'
    }),
    optionRatio () {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
          labels: {
            fontColor: this.$vuetify.theme.dark ? '#DDDDDD' : '#212121'
          }
        },
        scales: {
          xAxes: [{
            scaleLabel: {
              display: false
            },
            ticks: {
              fontColor: this.$vuetify.theme.dark ? '#DDDDDD' : '#212121'
            },
            stacked: true
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              stepSize: 50,
              fontColor: this.$vuetify.theme.dark ? '#DDDDDD' : '#212121'
            },
            stacked: true
          }]
        },
        plugins: {
          stacked100: { enable: true },
          datalabels: {
            display: false
          }
        }
      }
    },
    optionBarFee () {
      return {
        responsive: true,
        maintainAspectRatio: false,
        // title: {
        //   display: true,
        //   text: '売上推移',
        //   position: 'bottom'
        // },
        legend: {
          labels: {
            fontColor: this.$vuetify.theme.dark ? '#DDDDDD' : '#212121'
          }
        },
        scales: {
          xAxes: [{
            scaleLabel: {
              display: false
            },
            ticks: {
              fontColor: this.$vuetify.theme.dark ? '#DDDDDD' : '#212121'
            },
            stacked: true
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              stepSize: 500,
              fontColor: this.$vuetify.theme.dark ? '#DDDDDD' : '#212121'
            },
            stacked: true
          }]
        },
        plugins: {
          datalabels: {
            align: function (context) {
              var index = context.dataIndex
              var value = context.dataset.data[index]
              return value < 100 ? 'end' : 'start'
            },
            anchor: 'end',
            backgroundColor: null,
            borderColor: null,
            borderRadius: 4,
            borderWidth: 1,
            color: this.$vuetify.theme.dark ? '#DDDDDD' : '#212121',
            padding: 0,
            formatter: function (value) {
              return Math.round(value * 10) / 10
            }
          }
        }
      }
    },
    optionPie () {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: 'right',
          labels: {
            fontColor: this.$vuetify.theme.dark ? '#DDDDDD' : '#212121'
          }
        },
        plugins: {
          datalabels: {
            color: this.$vuetify.theme.dark ? '#DDDDDD' : '#212121'
          }
        }
      }
    },
    dataPie () {
      var temp = []
      if (this.preschool && this.extension === 1) {
        for (var i = 26; i < 30; i++) {
          if (typeof this.revices[this.group] !== 'undefined') {
            if (this.revices[this.group][this.mm - 1].enable) {
              temp.push(this.revices[this.group][this.mm - 1][i].value)
              continue
            }
          }
          temp.push(this.items[this.group][this.mm - 1][i].length)
        }
        for (i = 1; i < 14; i++) {
          if (typeof this.revices[this.group] !== 'undefined') {
            if (this.revices[this.group][this.mm - 1].enable) {
              temp.push(this.revices[this.group][this.mm - 1][i].value)
              continue
            }
          }
          temp.push(this.items[this.group][this.mm - 1][i].length)
        }
      } else if (this.preschool) {
        for (i = 0; i < 14; i++) {
          if (typeof this.revices[this.group] !== 'undefined') {
            if (this.revices[this.group][this.mm - 1].enable) {
              temp.push(this.revices[this.group][this.mm - 1][i].value)
              continue
            }
          }
          temp.push(this.items[this.group][this.mm - 1][i].length)
        }
      } else {
        for (i = 1; i < 14; i++) {
          if (typeof this.revices[this.group] !== 'undefined') {
            if (this.revices[this.group][this.mm - 1].enable) {
              temp.push(this.revices[this.group][this.mm - 1][i].value)
              continue
            }
          }
          temp.push(this.items[this.group][this.mm - 1][i].length)
        }
      }
      if (this.preschool) {
        if (this.extension === 1) {
          return {
            labels: ['3歳', '4歳', '5歳', '6歳', '小1', '小2', '小3', '小4', '小5', '小6', '中1', '中2', '中3', '高1', '高2', '高3', '社会人'],
            datasets: [
              {
                data: temp,
                backgroundColor: [
                  'rgba(76, 175, 80, 0.2)',
                  'rgba(76, 175, 80, 0.4)',
                  'rgba(76, 175, 80, 0.6)',
                  'rgba(76, 175, 80, 0.8)',
                  'rgba(255, 99, 132, 0.2)',
                  'rgba(255, 99, 132, 0.3)',
                  'rgba(255, 99, 132, 0.4)',
                  'rgba(255, 99, 132, 0.6)',
                  'rgba(255, 99, 132, 0.8)',
                  'rgba(255, 99, 132, 1)',
                  'rgba(54, 162, 235, 0.6)',
                  'rgba(54, 162, 235, 0.8)',
                  'rgba(54, 162, 235, 1)',
                  'rgba(255, 206, 86, 0.4)',
                  'rgba(255, 206, 86, 0.6)',
                  'rgba(255, 206, 86, 0.8)',
                  'rgba(255, 206, 86, 1)'
                ],
                borderWidth: 0.2
              }
            ]
          }
        } else {
          return {
            labels: ['幼児', '小1', '小2', '小3', '小4', '小5', '小6', '中1', '中2', '中3', '高1', '高2', '高3', '既卒'],
            datasets: [
              {
                data: temp,
                backgroundColor: [
                  'rgba(76, 175, 80, 0.8)',
                  'rgba(255, 99, 132, 0.2)',
                  'rgba(255, 99, 132, 0.3)',
                  'rgba(255, 99, 132, 0.4)',
                  'rgba(255, 99, 132, 0.6)',
                  'rgba(255, 99, 132, 0.8)',
                  'rgba(255, 99, 132, 1)',
                  'rgba(54, 162, 235, 0.6)',
                  'rgba(54, 162, 235, 0.8)',
                  'rgba(54, 162, 235, 1)',
                  'rgba(255, 206, 86, 0.4)',
                  'rgba(255, 206, 86, 0.6)',
                  'rgba(255, 206, 86, 0.8)',
                  'rgba(255, 206, 86, 1)'
                ],
                borderWidth: 0.2
              }
            ]
          }
        }
      } else {
        return {
          labels: ['小1', '小2', '小3', '小4', '小5', '小6', '中1', '中2', '中3', '高1', '高2', '高3', '既卒'],
          datasets: [
            {
              data: temp,
              backgroundColor: [
                'rgba(255, 99, 132, 0.2)',
                'rgba(255, 99, 132, 0.3)',
                'rgba(255, 99, 132, 0.4)',
                'rgba(255, 99, 132, 0.6)',
                'rgba(255, 99, 132, 0.8)',
                'rgba(255, 99, 132, 1)',
                'rgba(54, 162, 235, 0.6)',
                'rgba(54, 162, 235, 0.8)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 0.4)',
                'rgba(255, 206, 86, 0.6)',
                'rgba(255, 206, 86, 0.8)',
                'rgba(255, 206, 86, 1)'
              ],
              borderWidth: 0.2
            }
          ]
        }
      }
    }
  },
  watch: {
    group () {
      this.createGraph()
    },
    items () {
      this.createGraph()
    },
    fees () {
      this.createGraph()
    },
    year () {
      this.createGraph()
    },
    compare () {
      this.createGraph()
    }
  },
  data () {
    return {
      gData: {},
      gFreeData: {},
      gOption: {},
      gDataMin: 0,
      gDataMax: 0,
      gDataMaxA: 0,
      gDiffData: {}
    }
  },
  created () {
    this.createGraph()
  },
  methods: {
    initial () {
      this.gDataMaxA = 0
      this.gDataMax = 0
      this.gData = {}
      this.gOption = {}
      this.gFreeData = {}
    },
    createGraph () {
      this.initial()
      if (this.type === 'enrollment') {
        this.enrollment(this.group)
        this.optionBar(this.group, 0)
      } else if (this.type === 'io') {
        this.io(this.group)
        this.optionBar(this.group, 1)
      } else if (this.type === 'ratio') {
        this.pie(this.group)
      } else if (this.type === 'fee') {
        this.dataBarFee(this.group)
      }
    },
    dataBarFee (group) {
      var tempE = []
      var tempJ = []
      var tempH = []
      var tempI = []
      if (typeof this.fees[group] === 'undefined') {
        for (var i = 0; i < 12; i++) {
          if (this.preschool) {
            if (this.extension === 1) {
              tempI[i] = 0
            } else {
              tempI[i] = 0
            }
          }
          tempE[i] = 0
          tempJ[i] = 0
          tempH[i] = 0
        }
      } else {
        for (i = 0; i < 12; i++) {
          if (this.preschool) {
            if (this.extension === 1) {
              tempI[i] = this.fees[group][i][230].value
            } else {
              tempI[i] = this.fees[group][i][200].value
            }
          }
          tempE[i] = this.fees[group][i][214].value
          tempJ[i] = this.fees[group][i][215].value
          tempH[i] = this.fees[group][i][216].value
        }
      }
      if (this.preschool) {
        Vue.set(this.gFreeData, group, {
          labels: ['4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月', '1月', '2月', '3月'],
          datasets: [
            {
              label: '幼児',
              data: tempI,
              backgroundColor: 'rgba(76, 175, 80, 0.8)'
            },
            {
              label: '小学部',
              data: tempE,
              backgroundColor: 'rgba(255, 99, 132, 0.8)'
            },
            {
              label: '中学部',
              data: tempJ,
              backgroundColor: 'rgba(54, 162, 235, 0.8)'
            },
            {
              label: '高校部',
              data: tempH,
              backgroundColor: 'rgba(255, 206, 86, 0.8)'
            }
          ]
        })
      } else {
        Vue.set(this.gFreeData, group, {
          labels: ['4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月', '1月', '2月', '3月'],
          datasets: [
            {
              label: '小学部',
              data: tempE,
              backgroundColor: 'rgba(255, 99, 132, 0.8)'
            },
            {
              label: '中学部',
              data: tempJ,
              backgroundColor: 'rgba(54, 162, 235, 0.8)'
            },
            {
              label: '高校部',
              data: tempH,
              backgroundColor: 'rgba(255, 206, 86, 0.8)'
            }
          ]
        })
      }
    },
    enrollment (group) {
      var v0 = 0
      var v1 = 0
      var v2 = 0
      var v3 = 0

      var temp0 = []
      var temp1 = []
      var temp2 = []
      var temp3 = []

      var temp0D = []
      var temp1D = []
      var temp2D = []
      var temp3D = []

      for (var i = 0; i < 12; i++) {
        temp0[i] = v0 = this.items[this.group][i][14].length
        temp1[i] = v1 = this.items[this.group][i][15].length
        temp2[i] = v2 = this.items[this.group][i][16].length
        if (this.preschool) {
          if (this.extension === 1) {
            temp3[i] = v3 = this.items[group][i][30].length
          } else {
            temp3[i] = v3 = this.items[group][i][0].length
          }
        }
        if (this.revices[group] && this.revices[group][i].enable) {
          temp0[i] = v0 = this.revices[group][i][14].value
          temp1[i] = v1 = this.revices[group][i][15].value
          temp2[i] = v2 = this.revices[group][i][16].value
          if (this.preschool) {
            if (this.extension === 1) {
              temp3[i] = v3 = this.revices[group][i][30].value
            } else {
              temp3[i] = v3 = this.revices[group][i][0].value
            }
          }
        }
        if (group === '*') {
          if (this.preschool) {
            if (this.gDataMaxA < (v0 + v1 + v2 + v3)) {
              this.gDataMaxA = (Math.round((v0 + v1 + v2 + v3) / 50) + 1) * 50
            } else {
              if (this.gDataMaxA < (v0 + v1 + v2)) {
                this.gDataMaxA = (Math.round((v0 + v1 + v2) / 50) + 1) * 50
              }
            }
          }
        } else {
          if (this.preschool) {
            if (this.gDataMax < (v0 + v1 + v2 + v3)) {
              this.gDataMax = (Math.round((v0 + v1 + v2 + v3) / 20) + 1) * 20
            }
          } else {
            if (this.gDataMax < (v0 + v1 + v2)) {
              this.gDataMax = (Math.round((v0 + v1 + v2) / 20) + 1) * 20
            }
          }
        }
        if (this.compare === '目標') {
          temp0D[i] = v0 = this.plans[group][i][14].value
          temp1D[i] = v1 = this.plans[group][i][15].value
          temp2D[i] = v2 = this.plans[group][i][16].value
          if (this.preschool) {
            if (this.extension === 1) {
              temp3D[i] = v3 = this.plans[group][i][30].value
            } else {
              temp3D[i] = v3 = this.plans[group][i][0].value
            }
          }
        } else if (this.compare !== 'N/A') {
          if (this.diffsRevises[group] && this.diffsRevises[group][i].enable) {
            temp0D[i] = v0 = this.diffsRevises[group][i][14].value
            temp1D[i] = v1 = this.diffsRevises[group][i][15].value
            temp2D[i] = v2 = this.diffsRevises[group][i][16].value
            if (this.preschool) {
              if (this.extension === 1) {
                temp3D[i] = v3 = this.diffsRevises[group][i][30].value
              } else {
                temp3D[i] = v3 = this.diffsRevises[group][i][0].value
              }
            }
          } else {
            temp0D[i] = v0 = this.diffs[group][i][14].length
            temp1D[i] = v1 = this.diffs[group][i][15].length
            temp2D[i] = v2 = this.diffs[group][i][16].length
            if (this.preschool) {
              if (this.extension === 1) {
                temp3D[i] = v3 = this.diffs[group][i][30].length
              } else {
                temp3D[i] = v3 = this.diffs[group][i][0].length
              }
            }
          }
        }
        if (group === '*') {
          if (this.preschool) {
            if (this.gDataMaxA < (v0 + v1 + v2 + v3)) {
              this.gDataMaxA = (Math.round((v0 + v1 + v2 + v3) / 50) + 1) * 50
            }
          } else {
            if (this.gDataMaxA < (v0 + v1 + v2)) {
              this.gDataMaxA = (Math.round((v0 + v1 + v2) / 50) + 1) * 50
            }
          }
        } else {
          if (this.preschool) {
            if (this.gDataMax < (v0 + v1 + v2 + v3)) {
              this.gDataMax = (Math.round((v0 + v1 + v2 + v3) / 20) + 1) * 20
            }
          } else {
            if (this.gDataMax < (v0 + v1 + v2)) {
              this.gDataMax = (Math.round((v0 + v1 + v2) / 20) + 1) * 20
            }
          }
        }
      }
      var dataset = []
      if (this.preschool) {
        dataset.push(
          {
            label: '幼児',
            data: temp3,
            stack: 'A',
            backgroundColor: 'rgba(76, 175, 80, 0.8)'
          },
          {
            label: '小学部',
            data: temp0,
            stack: 'A',
            backgroundColor: 'rgba(255, 99, 132, 0.8)'
          },
          {
            label: '中学部',
            data: temp1,
            stack: 'A',
            backgroundColor: 'rgba(54, 162, 235, 0.8)'
          },
          {
            label: '高校部',
            data: temp2,
            stack: 'A',
            backgroundColor: 'rgba(255, 206, 86, 0.8)'
          }
        )
      } else {
        if (this.preschool) {
          dataset.push(
            {
              label: '幼児',
              data: temp3,
              stack: 'A',
              backgroundColor: 'rgba(76, 175, 80, 0.8)'
            },
            {
              label: '小学部',
              data: temp0,
              stack: 'A',
              backgroundColor: 'rgba(255, 99, 132, 0.8)'
            },
            {
              label: '中学部',
              data: temp1,
              stack: 'A',
              backgroundColor: 'rgba(54, 162, 235, 0.8)'
            },
            {
              label: '高校部',
              data: temp2,
              stack: 'A',
              backgroundColor: 'rgba(255, 206, 86, 0.8)'
            }
          )
        } else {
          dataset.push(
            {
              label: '小学部',
              data: temp0,
              stack: 'A',
              backgroundColor: 'rgba(255, 99, 132, 0.8)'
            },
            {
              label: '中学部',
              data: temp1,
              stack: 'A',
              backgroundColor: 'rgba(54, 162, 235, 0.8)'
            },
            {
              label: '高校部',
              data: temp2,
              stack: 'A',
              backgroundColor: 'rgba(255, 206, 86, 0.8)'
            }
          )
        }
      }
      if (this.compare !== 'N/A') {
        if (this.preschool) {
          dataset.push(
            {
              label: '幼児',
              data: temp3D,
              stack: 'B',
              backgroundColor: 'rgba(76, 175, 80, 0.8)'
            },
            {
              label: '小学部',
              data: temp0D,
              stack: 'B',
              backgroundColor: 'rgba(255, 99, 132, 0.5)'
            },
            {
              label: '中学部',
              data: temp1D,
              stack: 'B',
              backgroundColor: 'rgba(54, 162, 235, 0.5)'
            },
            {
              label: '高校部',
              data: temp2D,
              stack: 'B',
              backgroundColor: 'rgba(255, 206, 86, 0.5)'
            }
          )
        } else {
          dataset.push(
            {
              label: '小学部',
              data: temp0D,
              stack: 'B',
              backgroundColor: 'rgba(255, 99, 132, 0.5)'
            },
            {
              label: '中学部',
              data: temp1D,
              stack: 'B',
              backgroundColor: 'rgba(54, 162, 235, 0.5)'
            },
            {
              label: '高校部',
              data: temp2D,
              stack: 'B',
              backgroundColor: 'rgba(255, 206, 86, 0.5)'
            }
          )
        }
      }
      Vue.set(this.gData, group, {
        labels: ['4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月', '1月', '2月', '3月'],
        datasets: dataset
      })
    },
    io (group) {
      var temp0 = []
      var temp1 = []
      for (var i = 0; i < 12; i++) {
        temp0[i] = this.inout[group][i][17][0].length
        temp1[i] = 0 - this.inout[group][i][17][1].length
      }
      Vue.set(this.gData, group, {
        labels: ['4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月', '1月', '2月', '3月'],
        datasets: [
          {
            label: this.extension === 1 ? '入会' : '入塾',
            data: temp0,
            backgroundColor: 'rgba(255, 99, 132, 0.8)'
          },
          {
            label: this.extension === 1 ? '退会' : '退塾',
            data: temp1,
            backgroundColor: 'rgba(54, 162, 235, 0.8)'
          }
        ]
      })
    },
    pie (group) {
      var dataset = []
      var items = []
      if (this.preschool) {
        if (this.extension === 1) {
          items = [
            { name: '3歳', color: 'rgba(76, 175, 80, 0.2)' },
            { name: '4歳', color: 'rgba(76, 175, 80, 0.4)' },
            { name: '5歳', color: 'rgba(76, 175, 80, 0.6)' },
            { name: '6歳', color: 'rgba(76, 175, 80, 0.8)' },
            { name: '小1', color: 'rgba(255, 99, 132, 0.2)' },
            { name: '小2', color: 'rgba(255, 99, 132, 0.3)' },
            { name: '小3', color: 'rgba(255, 99, 132, 0.4)' },
            { name: '小4', color: 'rgba(255, 99, 132, 0.6)' },
            { name: '小5', color: 'rgba(255, 99, 132, 0.8)' },
            { name: '小6', color: 'rgba(255, 99, 132, 1)' },
            { name: '中1', color: 'rgba(54, 162, 235, 0.6)' },
            { name: '中2', color: 'rgba(54, 162, 235, 0.8)' },
            { name: '中3', color: 'rgba(54, 162, 235, 1)' },
            { name: '高1', color: 'rgba(255, 206, 86, 0.4)' },
            { name: '高2', color: 'rgba(255, 206, 86, 0.6)' },
            { name: '高3', color: 'rgba(255, 206, 86, 0.8)' },
            { name: '社会人', color: 'rgba(255, 206, 86, 1)' }
          ]
        } else {
          items = [
            { name: '幼児', color: 'rgba(76, 175, 80, 1)' },
            { name: '小1', color: 'rgba(255, 99, 132, 0.2)' },
            { name: '小2', color: 'rgba(255, 99, 132, 0.3)' },
            { name: '小3', color: 'rgba(255, 99, 132, 0.4)' },
            { name: '小4', color: 'rgba(255, 99, 132, 0.6)' },
            { name: '小5', color: 'rgba(255, 99, 132, 0.8)' },
            { name: '小6', color: 'rgba(255, 99, 132, 1)' },
            { name: '中1', color: 'rgba(54, 162, 235, 0.6)' },
            { name: '中2', color: 'rgba(54, 162, 235, 0.8)' },
            { name: '中3', color: 'rgba(54, 162, 235, 1)' },
            { name: '高1', color: 'rgba(255, 206, 86, 0.4)' },
            { name: '高2', color: 'rgba(255, 206, 86, 0.6)' },
            { name: '高3', color: 'rgba(255, 206, 86, 0.8)' },
            { name: '既卒', color: 'rgba(255, 206, 86, 1)' }
          ]
        }
      } else {
        items = [
          { name: '小1', color: 'rgba(255, 99, 132, 0.2)' },
          { name: '小2', color: 'rgba(255, 99, 132, 0.3)' },
          { name: '小3', color: 'rgba(255, 99, 132, 0.4)' },
          { name: '小4', color: 'rgba(255, 99, 132, 0.6)' },
          { name: '小5', color: 'rgba(255, 99, 132, 0.8)' },
          { name: '小6', color: 'rgba(255, 99, 132, 1)' },
          { name: '中1', color: 'rgba(54, 162, 235, 0.6)' },
          { name: '中2', color: 'rgba(54, 162, 235, 0.8)' },
          { name: '中3', color: 'rgba(54, 162, 235, 1)' },
          { name: '高1', color: 'rgba(255, 206, 86, 0.4)' },
          { name: '高2', color: 'rgba(255, 206, 86, 0.6)' },
          { name: '高3', color: 'rgba(255, 206, 86, 0.8)' },
          { name: '既卒', color: 'rgba(255, 206, 86, 1)' }
        ]
      }
      if (this.preschool && this.extension === 1) {
        for (var x = 26; x < 30; x++) {
          dataset = dataset.concat(this.calcRatioData(items, group, x))
        }
        for (x = 1; x < 14; x++) {
          dataset = dataset.concat(this.calcRatioData(items, group, x))
        }
      } else if (this.preschool) {
        for (x = 0; x < 14; x++) {
          dataset = dataset.concat(this.calcRatioData(items, group, x))
        }
      } else {
        for (x = 1; x < 14; x++) {
          dataset = dataset.concat(this.calcRatioData(items, group, x))
        }
      }
      Vue.set(this.gData, group, {
        labels: ['4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月', '1月', '2月', '3月'],
        datasets: dataset
      })
    },
    calcRatioData (items, group, x) {
      var dataset = []
      var temp = []
      var diff = []
      for (var i = 0; i < 12; i++) {
        temp[i] = this.items[group][i][x].length
        if (this.revices[group] && this.revices[group][i].enable) {
          temp[i] = this.revices[group][i][x].value
        }
        if (this.compare === '目標') {
          diff[i] = this.plans[group][i][x].value
        } else if (this.compare !== 'N/A') {
          if (this.diffsRevises[group] && this.diffsRevises[group][i].enable) {
            diff[i] = this.diffsRevises[group][i][x].value
          } else {
            diff[i] = this.diffs[group][i][x].length
          }
        }
      }
      if (this.preschool && this.extension === 1) {
        if (x >= 26) {
          x -= 26
        } else {
          x += 3
        }
      }
      if (this.preschool) {
        dataset.push(
          {
            label: items[x].name,
            data: temp,
            stack: 'A',
            backgroundColor: items[x].color
          }
        )
      } else {
        dataset.push(
          {
            label: items[x - 1].name,
            data: temp,
            stack: 'A',
            backgroundColor: items[x - 1].color
          }
        )
      }
      if (this.compare !== 'N/A') {
        if (this.preschool) {
          dataset.push(
            {
              label: items[x].name,
              data: diff,
              stack: 'B',
              backgroundColor: items[x].color
            }
          )
        } else {
          dataset.push(
            {
              label: items[x - 1].name,
              data: diff,
              stack: 'B',
              backgroundColor: items[x - 1].color
            }
          )
        }
      }
      return dataset
    },
    optionBar (group, type) {
      var vm = this
      var temp = {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          labels: {
            fontColor: this.$vuetify.theme.dark ? '#DDDDDD' : '#212121'
          }
        }
      }
      if (type === 0) {
        temp['scales'] = {
          xAxes: [{
            scaleLabel: {
              display: false
            },
            ticks: {
              fontColor: this.$vuetify.theme.dark ? '#DDDDDD' : '#212121'
            },
            stacked: true
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              stepSize: group === '*' ? 50 : 20,
              min: this.gDataMin,
              max: group === '*' ? this.gDataMaxA : this.gDataMax,
              fontColor: this.$vuetify.theme.dark ? '#DDDDDD' : '#212121'
            },
            stacked: true
          }]
        }
        temp['plugins'] = {
          stacked100: { enable: false },
          datalabels: {
            align: function (context) {
              var index = context.dataIndex
              var value = context.dataset.data[index]
              return value < 10 ? 'end' : 'start'
            },
            anchor: 'end',
            backgroundColor: null,
            borderColor: null,
            borderRadius: 4,
            borderWidth: 1,
            color: this.$vuetify.theme.dark ? '#DDDDDD' : '#212121',
            padding: 0,
            formatter: function (value) {
              return Math.round(value * 10) / 10
            }
          }
        }
        Vue.set(this.gOption, group, temp)
      } else {
        temp['scales'] = {
          xAxes: [{
            scaleLabel: {
              display: false
            },
            ticks: {
              fontColor: this.$vuetify.theme.dark ? '#DDDDDD' : '#212121'
            },
            stacked: true
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              stepSize: 20,
              min: -60,
              max: 60,
              fontColor: this.$vuetify.theme.dark ? '#DDDDDD' : '#212121'
            },
            stacked: true
          }]
        }
        temp['plugins'] = {
          datalabels: {
            align: function (context) {
              var index = context.dataIndex
              var value = context.dataset.data[index]
              return value <= 0 ? 'start' : 'end'
            },
            anchor: function (context) {
              var index = context.dataIndex
              var value = context.dataset.data[index]
              return value <= 0 ? 'start' : 'end'
            },
            backgroundColor: null,
            borderColor: null,
            borderRadius: 4,
            borderWidth: 1,
            color: function (context) {
              var index = context.dataIndex
              var value = context.dataset.data[index]
              if (value === 0) {
                return '#00000000'
              }
              return vm.$vuetify.theme.dark ? '#DDDDDD' : '#212121'
            },
            padding: 0,
            formatter: function (value) {
              return Math.round(value * 10) / 10
            }
          }
        }
        Vue.set(this.gOption, group, temp)
      }
    }
  }
}
</script>
